module.exports = __webpack_public_path__ + "static/case_solution-476d3629c4d9acee143eaa59b87fd623.svg";